import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { 
    IonIcon
} from '@ionic/angular/standalone';

@Component({
    selector: 'marv-rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.scss'],
    imports: [IonIcon]
})
export class MarvRatingComponent  implements OnInit {

    @Input({alias : 'value', required : true}) ratingValue: number|null;
    @Input({alias : 'max', required : true}) ratingMax: number;
    @Input({alias : 'size', required : false}) size: 'big'|'medium'|'small' = 'medium';
    @Output() onSelectRating = new EventEmitter<number>();
    
    ratings: Array<number> = [];
    
    constructor() {}

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        if(changes['ratingMax']){
            this.getRatings();
        }
    }
    
    getRatings(){
        let ratings: Array<number> = [];
        for(let i=1; i<=this.ratingMax; i++){
            ratings.push(i);
        }
        this.ratings = ratings;
    }
    
    selectRating(rating: number){
        this.ratingValue = rating;
        this.onSelectRating.emit(rating);
    }
}
